import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { FileText } from 'lucide-react';

export function ConsultationFormDialog({
  open,
  onOpenChange,
  consultationForm,
  consultationBooking,
  formAnswers,
  setFormAnswers,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2">
            <FileText className="h-5 w-5 text-[#D4AF37]" />
            {consultationForm?.name || 'Consultation Form'}
          </DialogTitle>
        </DialogHeader>
        {consultationForm && (
          <div className="space-y-5 py-2" data-testid="consultation-form-fill">
            <p className="text-sm text-stone-500">
              Please fill out this pre-appointment form for your booking with {consultationBooking?.provider_name}.
            </p>
            {consultationForm.questions.map((q, idx) => (
              <div key={q.question_id || idx} className="space-y-2" data-testid={`consultation-q-${idx}`}>
                <Label className="text-sm font-medium text-[#1A1A1A]">
                  {q.text} {q.required && <span className="text-red-500">*</span>}
                </Label>
                {q.type === 'text' && (
                  <Textarea value={formAnswers[q.question_id] || ''} onChange={e => setFormAnswers(prev => ({ ...prev, [q.question_id]: e.target.value }))} className="input-zuriya min-h-[80px]" placeholder="Your answer..." />
                )}
                {q.type === 'yes_no' && (
                  <RadioGroup value={formAnswers[q.question_id] || ''} onValueChange={val => setFormAnswers(prev => ({ ...prev, [q.question_id]: val }))} className="flex gap-4">
                    <div className="flex items-center gap-2"><RadioGroupItem value="yes" id={`${q.question_id}-yes`} /><Label htmlFor={`${q.question_id}-yes`}>Yes</Label></div>
                    <div className="flex items-center gap-2"><RadioGroupItem value="no" id={`${q.question_id}-no`} /><Label htmlFor={`${q.question_id}-no`}>No</Label></div>
                  </RadioGroup>
                )}
                {q.type === 'multiple_choice' && q.options && (
                  <RadioGroup value={formAnswers[q.question_id] || ''} onValueChange={val => setFormAnswers(prev => ({ ...prev, [q.question_id]: val }))} className="space-y-2">
                    {q.options.map((opt, oIdx) => (
                      <div key={`${q.question_id}-opt-${oIdx}`} className="flex items-center gap-2"><RadioGroupItem value={opt} id={`${q.question_id}-${oIdx}`} /><Label htmlFor={`${q.question_id}-${oIdx}`}>{opt}</Label></div>
                    ))}
                  </RadioGroup>
                )}
              </div>
            ))}
            <Button onClick={onSubmit} className="btn-primary w-full" data-testid="submit-consultation-btn">Submit Consultation Form</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
